import { render, staticRenderFns } from "./BookingSettings.vue?vue&type=template&id=90998940&scoped=true"
import script from "./BookingSettings.vue?vue&type=script&lang=js"
export * from "./BookingSettings.vue?vue&type=script&lang=js"
import style0 from "./BookingSettings.vue?vue&type=style&index=0&id=90998940&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90998940",
  null
  
)

export default component.exports